// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import { useMemo, useState } from 'react';
import { createContainer } from 'unstated-next';

function useSegmentProvider() {
  const [segmentId, setSegmentId] = useState(null);

  const result = useMemo(
    () => ({
      segmentId,
      setSegmentId,
    }),
    [segmentId, setSegmentId]
  );

  return result;
}

export const SegmentProvider = createContainer(useSegmentProvider);
